export default "__VITE_ASSET__Bv1Ys6SN__"